import { useDocumentTitle } from "@uidotdev/usehooks";
import { AnalyticsView } from "../components/Analytics";
import { PermissionGate } from "./PermissionGate";

export const AnalyticsPage = () => {
    useDocumentTitle("Analytics - AERSHED");

    return (
        <PermissionGate permission="emissionView">
            <AnalyticsView />
        </PermissionGate>
    );
};
